import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import classNames from "classnames"

const Image = ({ blok, className = "", lazy=true }) => {
  const styles = {}
  blok.max_height && (styles.maxHeight = parseInt(blok.max_height))
  blok.max_width && (styles.maxWidth = parseInt(blok.max_width))

  return (
    blok.image?.filename && (
      <div
        {...storyblokEditable(blok)}
        key={blok._uid}
        className={classNames("image-wrapper component", className, {
          "align-center": blok.align_center,
        })}
      >
        <img
          className="gs_reveal_img"
          src={blok.image.filename}
          alt={blok.image.alt}
          title={blok.image.title}
          style={styles}
          loading={(lazy) ? 'lazy' : 'eager'}
        />
      </div>
    )
  )
}

export default Image
